export { default } from './FAQ';